<template>
  <div class="page page-home" ref="wrapper">
    <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { Sticky } from 'vant';

export default {
  data() {
    return {};
  },
  components: {
    [Sticky.name]: Sticky
  },
  created() {},
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
    window.addEventListener(
      'popstate',
      function(e) {
        e.preventDefault();
      },
      false
    );
  },
  activated() {
    let scrollTop = window.localStorage.getItem('scrollTop');
    this.$refs.wrapper.scrollTop = scrollTop;
  },
  methods: {
    handleScroll() {
      let scrollTop = this.$refs.wrapper.scrollTop;
      window.localStorage.setItem('scrollTop', scrollTop);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-home {
  font-family: PingFang SC;
  // background: #f2f2f2;
  height: 100%;
  position: relative;
  // overflow-y: auto;
  width: 100%;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch; //有回弹效果;
}
</style>
<style scoped></style>
